/* import __COLOCATED_TEMPLATE__ from './multi-select-filter.hbs.js'; */
import { action } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { classNames } from "@ember-decorators/component";
import discourseComputed from "discourse/lib/decorators";
import SelectKitFilterComponent from "select-kit/components/select-kit/select-kit-filter";
const MultiSelectFilter = dt7948.c(class MultiSelectFilter extends SelectKitFilterComponent {
  computedPlaceholder(placeholder, hasSelection) {
    if (this.hidePlaceholderWithSelection && hasSelection) {
      return "";
    }
    return isEmpty(placeholder) ? "" : placeholder;
  }
  static {
    dt7948.n(this.prototype, "computedPlaceholder", [discourseComputed("placeholder", "selectKit.hasSelection")]);
  }
  onPaste(event) {
    const data = event?.clipboardData;
    if (!data) {
      return;
    }
    const parts = data.getData("text").split("|").filter(Boolean);
    if (parts.length > 1) {
      event.stopPropagation();
      event.preventDefault();
      this.selectKit.append(parts);
      return false;
    }
  }
  static {
    dt7948.n(this.prototype, "onPaste", [action]);
  }
}, [classNames("multi-select-filter")]);
export default MultiSelectFilter;